var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"itBox"},[_c('div',{staticClass:"textBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.list.title))]),_c('div',{staticClass:"en"},[_vm._v(_vm._s(_vm.list.en))]),_c('div',{staticClass:"pp"},[_vm._v(_vm._s(_vm.list.pp))])]),_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":_vm.list.img,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }